import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    flavorsCostContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    graphTitle: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '20px 0px 16px',
    },
    flavorsCostTable: {
      height: '100%',
      '& .MuiTableCell-head .MuiGrid-root': {
        color: `${palette.offWhite} !important`,
      },
    },
  });

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
